import { FormInstance } from 'antd'
import { DirectionKey, Flow, ScopeMode, TypeKey } from './types'

/**
 * Determine the mapping flow from the (initial) form values. A record is `inbound`
 * when an external value arrived but our side (`ourSideField`, e.g. `specie_uuid`,
 * `color_key`, `size_key`) is still unset.
 */
export const resolveFlow = (form: FormInstance, ourSideField: string): Flow => {
  const externalId = form.getFieldValue('external_id')
  const ourValue = form.getFieldValue(ourSideField)
  return externalId && !ourValue ? 'inbound' : 'outbound'
}

/** Determine the mapping scope from the (initial) form values. */
export const resolveScopeMode = (form: FormInstance): ScopeMode =>
  form.getFieldValue('shelter_uuid') ? 'shelter' : 'global'

/** Determine the mapping type from the (initial) form values. */
export const resolveTypeKey = (form: FormInstance): TypeKey =>
  form.getFieldValue('type_key') === 'MATCH' ? 'MATCH' : 'DIRECT'

/** Determine the MATCH direction from the (initial) form values. */
export const resolveDirectionKey = (form: FormInstance): DirectionKey =>
  form.getFieldValue('direction_key') === 'OUTPUT' ? 'OUTPUT' : 'INPUT'
